import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PopOutIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "PopOut",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M24.46 2h-9.73c-2.09 0-3.79 1.7-3.79 3.79v4.89a1.05 1.05 0 1 0 2.1 0V5.79c0-.94.76-1.7 1.7-1.7h9.73c.94 0 1.7.76 1.7 1.7v20.42c0 .94-.76 1.7-1.7 1.7h-9.73c-.94 0-1.7-.76-1.7-1.7v-4.9a1.05 1.05 0 1 0-2.1 0v4.9c0 2.09 1.7 3.79 3.79 3.79h9.73c2.09 0 3.79-1.7 3.79-3.79V5.79c0-2.09-1.7-3.79-3.79-3.79m-4.87 15.05a1.05 1.05 0 1 0 0-2.1H9.06V12.5c0-.38-.31-.69-.69-.69-.18 0-.34.07-.46.18s-3.93 3.48-3.93 3.48c-.15.13-.24.32-.24.52s.09.4.24.52S7.88 20 7.88 20c.12.11.28.18.46.18.38 0 .69-.31.69-.69v-2.45h10.55Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M17.57 17H5a1.14 1.14 0 1 1 0-2.28h12.57a1.14 1.14 0 1 1 0 2.28"
      }), /*#__PURE__*/_jsx("path", {
        d: "M9.57 21.57c-.29 0-.58-.11-.81-.33l-4.57-4.57a1.16 1.16 0 0 1 0-1.62l4.57-4.57a1.15 1.15 0 0 1 1.62 0c.45.45.45 1.17 0 1.62l-3.76 3.76 3.76 3.76a1.14 1.14 0 0 1-.81 1.95"
      }), /*#__PURE__*/_jsx("path", {
        d: "M25.57 31.86H11.86c-1.89 0-3.43-1.54-3.43-3.43V25a1.14 1.14 0 1 1 2.28 0v3.43c0 .63.51 1.14 1.14 1.14h13.71c.63 0 1.14-.51 1.14-1.14V3.29c0-.63-.51-1.14-1.14-1.14H11.85c-.63 0-1.14.51-1.14 1.14v3.43a1.14 1.14 0 1 1-2.28 0V3.29c0-1.89 1.54-3.43 3.43-3.43h13.71C27.46-.14 29 1.4 29 3.29v25.14c0 1.89-1.54 3.43-3.43 3.43"
      })]
    })
  }));
};
PopOutIcon.displayName = 'PopOutIcon';